export enum EAppRoutes {
  Home = '/',
  Login = '/login',
  Logout = '/logout',
  Admin = '/admin',
  AdminUsersInvite = '/admin/users-invite',

  Inventory = '/inventory',
  CreateInventory = '/inventory/create',
  EditInventory = '/inventory/edit/:objectId/details',
  EditInventoryTargeting = '/inventory/edit/:objectId/targeting',
  EditInventoryAudiencesData = '/inventory/edit/:objectId/audiences-data',
  TargetingBulkEditDeals = '/inventory/bulk-edit',
  TargetingBulkEditOptimization = '/inventory/bulk-edit/optimization',
  EditInventoryDCO = '/inventory/edit/:objectId/dco',
  /**
   * TARGETING ROUTES
   * TODO: refactor targeting to separate route groups
   */
  // targeting technologyProfile
  TargetingDeviceType = 'technologyProfile/deviceType',
  TargetingOs = 'technologyProfile/operatingSystem',
  TargetingInventoryBrowser = 'technologyProfile/browser',
  TargetingCarrier = 'technologyProfile/carrier',
  // targeting placement
  TargetingBannerPlacement = 'placement/bannerPlacement',
  TargetingVideoPlacement = 'placement/videoPlacement',
  // targeting creatives
  TargetingCreativeBanner = 'creatives/banner',
  TargetingCreativeNative = 'creatives/native',
  TargetingCreativeAudio = 'creatives/audio',
  TargetingCreativeVideo = 'creatives/video',
  TargetingIabFormats = 'creatives/iabFormats',
  TargetingFrequency = 'frequency/frequency',
  TargetingSupplySource = 'inventory/supplySource',
  TargetingVerifiedSource = 'inventory/verifiedSource',
  TargetingInventoryDeals = 'inventory/deals',
  TargetingSiteAndApp = 'inventory/appSiteList',
  TargetingIabCategory = 'inventory/iabCategory',
  TargetingAppCategory = 'inventory/appCategory',
  TargetingDayParting = 'dayParting/dayPartingPanel',
  // targeting location
  TargetingLocationPOI = 'location/pointOfInterest',
  TargetingGeo = 'location/geographical',
  TargetingLanguage = 'content/language',
  TargetingGenre = 'content/genre',
  TargetingRating = 'content/rating',
  TargetingLive = 'content/live',
  TargetingProduction = 'content/production',
  ViewabilityProduction = 'prebid/viewability',
  ViewabilityBssAbs = 'prebid/bss-abs',

  /**
   * DATA AND AUDIENCE
   */
  DataAudience = '/data-audience',
  CreateLocationGroup = '/data-audience/locations/create',
  EditLocationGroup = '/data-audience/edit/locations/:locationGroupId',
  CreateCustomAudience = '/data-audience/create/custom-audience',
  UpdateCustomAudience = '/data-audience/overview/custom-audience/:id',
  CreateCustomPixel = '/data-audience/create/custom-pixel',
  EditCustomPixel = '/data-audience/edit/custom-pixel/:pixelId',
}

export enum MainMenuKeyType {
  Admin = 'admin',
  Inventory = 'inventory',
  DataAudience = 'dataAudience',
}

export enum CreativeType {
  Banner = 1,
  Audio = 2,
  Video = 3,
  Native = 4,
}

export enum Permission {
  CreateAccounts = 1,
  ManageAccount = 2,
  ViewAccount = 3,
  ManageAccountRoles = 4,
  ReadAccountRoles = 5,
  ManageAccountAgencies = 6,
  ReadAccountAgencies = 7,
  ManageAccountAdvertisers = 8,
  ReadAccountAdvertisers = 9,
  ManageAccountUsers = 10,
  ReadAccountUsers = 11,
  ManageAccountDeals = 12,
  ReadAccountDeals = 13,
  ManageDealAccountVisibilities = 14,
  ReadDealAccountVisibilities = 15,
  ManageAccountLineItems = 16,
  ReadAccountLineItems = 17,
  ManageAccountStrategies = 18,
  ReadAccountStrategies = 19,
  ReadPermissions = 20,
  ManagePermissions = 21,
  ReadAccountAudiences = 22,
  ManageAccountAudiences = 23,
  AccessAdminModule = 24,
  AccessCampaignModule = 25,
  AccessDealModule = 26,
  AccessCreativeModule = 27,
  AccessReportingModule = 28,
  AccessAudienceModule = 29,
  AccessPlanningModule = 30,
  AccessAllAccounts = 31,
  InternalUser = 34,
}

export enum UserIdentityProvider {
  Okta = 1,
  Auth0 = 2,
}
